import axios from "axios";
// import { getCookie } from '../controllers/DynamicCookies';

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:8090",
  withCredentials: true,
});

// Allow App.js to signal when token is ready
// Request interceptor
instance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    const store_id = localStorage.getItem("store_id");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    if (store_id) {
      config.headers.storeid = store_id;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor
instance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error),
);

export default instance;
